import script from "./FormElementEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./FormElementEdit.vue?vue&type=script&setup=true&lang=js"

import "./FormElementEdit.vue?vue&type=style&index=0&id=b9fdd400&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9fdd400"]])

export default __exports__